import { Http } from "@/api/http/fetch";
import {
  addDefaultParamsAndEncrypt,
  defaultResponse,
  responseBase64
} from "@/api/http/gx/gxInterceptor";
/**
 * 新实例化Http类，拦截器单独用户ins的请求
 */
const http = new Http();

/**
 *  [REQUEST] INTERCEPTORS
 *  添加默认参数并加密body
 */
http.interceptors.request.use(
  (config: any) => {
    return addDefaultParamsAndEncrypt(config);
  },
  (error: any) => {
    return Promise.reject(error);
  }
);
/**
 *  [RESPONSE] INTERCEPTORS
 *  请求后对cookie对应的id存储到对应的store内，对Error错误进行统一的管理处理
 */
http.interceptors.response.use(
  (res: any) => {
    return defaultResponse(res);
  },
  (error: any) => {
    return Promise.reject(error);
  }
);
http.interceptors.response.use(
  (res: any) => {
    return responseBase64(res);
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

/**
 * GX的普通GET请求
 * @param url
 * @param params=>body
 * @param extra
 */
export function get(url: string, params: any = null, extra: any = {}) {
  const data = {
    url,
    method: "GET",
    params,
    extra
  };
  return http.request(data);
}

/**
 * GX的普通Post请求
 * @param url
 * @param params=>body
 * @param extra
 */
export function post(url: string, body: any, extra: any = {}) {
  const data = {
    url,
    method: "POST",
    data: body,
    extra
  };
  return http.request(data);
}
